import { AxiosResponse } from "axios";

import { sendRawRequest } from "../request/axios";
import { AuthResponse } from "../types/auth.type";
import { AxiosHttpError } from "../types/error.type";
import { SocialLogin, UserLogin } from "../types/user.type";
import {
  storeAuthResult,
  storeSocialAuthResult,
} from "../utils/token/token.util";

export async function loginUser(input: UserLogin) {
  try {
    const res = await sendRawRequest<UserLogin, AxiosResponse<AuthResponse>>(
      "post",
      "/auth/token/",
      input
    );
    if (res.data) storeAuthResult(res.data);
    return true;
  } catch (error) {
    return false;
  }
}

export async function loginSocial(input: SocialLogin) {
  try {
    const res = await sendRawRequest<SocialLogin, AxiosResponse>(
      "post",
      "/auth/oauth/login/",
      input
    );
    if (res.data) storeSocialAuthResult(res.data.token as string);
    return { success: true };
  } catch (error) {
    console.log(error);
    const axiosError = error as AxiosHttpError;
    return {
      success: false,
      error: axiosError.response?.data,
    };
  }
}
